module.exports = __webpack_public_path__ + "static/media/1.0b11b55a.svg";